import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('@/views/AuthPage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomePage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/templates/create',
    name: 'CreateTemplate',
    component: () => import('@/views/CreateTemplatePage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/templates/:id/edit',
    name: 'EditTemplate',
    component: () => import('@/views/EditTemplatePage.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/templates/:id/preview',
    name: 'PreviewTemplate',
    component: () => import('@/views/PreviewTemplatePage.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/test/preview',
    name: 'PreviewTest',
    component: () => import('@/views/PreviewTestPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/test/ui',
    name: 'UITest',
    component: () => import('@/views/UITestPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/test/spacing',
    name: 'SpacingTest',
    component: () => import('@/views/SpacingTestPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/test/export',
    name: 'ExportTest',
    component: () => import('@/views/ExportTestPage.vue'),
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 路由守卫
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  // 如果路由不需要认证，直接通过
  if (to.meta.requiresAuth === false) {
    next()
    return
  }

  // 检查认证状态
  const isAuthenticated = await authStore.checkAuthStatus()

  if (isAuthenticated) {
    // 已认证，如果访问认证页面则重定向到首页
    if (to.name === 'Auth') {
      next({ name: 'Home' })
    } else {
      next()
    }
  } else {
    // 未认证，重定向到认证页面
    if (to.name !== 'Auth') {
      next({ name: 'Auth' })
    } else {
      next()
    }
  }
})

export default router
